<template>
  <div id="app">
    <MainPage></MainPage>
  </div>
</template>

<script>
import MainPage from "./components/MainPage.vue";
import axios from "axios";
export default {
  name: "App",
  components: {
    MainPage,
  },

  async created() {
    console.log("vue app prod value: ", process.env.VUE_APP_PROD);
    const apiToken = process.env.VUE_APP_API_TOKEN;
    axios.defaults.headers.common["Authorization"] = `Bearer ${apiToken}`;
    axios.defaults.baseURL = process.env.VUE_APP_API_URL;

    await this.$store.dispatch("currentUser/authCheck").then((response) => {
      if (response.success) {
        this.$store.dispatch("currentUser/setCurrentUser");
      }
    });
    console.log("token: ", process.env.VUE_APP_API_TOKEN);

    //this.$store.dispatch('currentTournament/getTournament', 144);
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: white;
  overflow: hidden;
}

::-webkit-scrollbar {
  width: 4px;
  height: 4px;
}

/* Track */
::-webkit-scrollbar-track {
  background: #010d11;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: var(--pink-variant);
}

/* Handle on hover */
::-webkit-scrollbar-thumb:hover {
  background: #555;
}
</style>
